export default __webpack_public_path__ + "static/G2Kosmos-Regular-d47c61ceb3bfe572734e499f1a6d0467.otf";